import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter, Inject,
  Input, OnChanges, OnInit,
  Output, SimpleChanges
} from "@angular/core";
import {AiAgentModel} from "../../../models/ai-agent.model";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {AiAgentsHttpService} from "../../services/ai-agents-http.service";
import {take} from "rxjs";

export interface AiAgentsSelectPanelData {
  agents?: AiAgentModel[];
  processingAgents?: string[];
  showTriggerRule?: boolean;
}

require('./ai-agent-select.scss');
@Component({
  standalone: false,
  selector: 'app-ai-agent-select',
  templateUrl: './ai-agent-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiAgentSelectComponent implements OnInit {
  @Output() onAgentsLoaded = new EventEmitter<AiAgentModel[]>();
  @Output() onAgentSelected = new EventEmitter<AiAgentModel>();
  @Output() onTriggerRule = new EventEmitter<void>();

  public agents: AiAgentModel[] = [];
  public processingAgents: { [key: string]: boolean } = {};
  public showTriggerRule: boolean = false;

  constructor(@Inject(PANEL_DATA) private data: AiAgentsSelectPanelData,
              @Inject(AiAgentsHttpService) private aiAgentsHttpService: AiAgentsHttpService,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    if (this.data?.showTriggerRule) {
      this.showTriggerRule = this.data.showTriggerRule;
    }

    if (this.data?.agents) {
      this.agents = this.data.agents;
    } else {
      this.aiAgentsHttpService
        .getAiAgents({ active: true })
        .pipe(take(1))
        .subscribe(response => {
          this.agents = response.list
          this.onAgentsLoaded.emit(this.agents);
          this.cdr.detectChanges();
        });
    }

    if (this.data?.processingAgents) {
      this.updateProcessingAgents(this.data.processingAgents);
    }
  }

  updateProcessingAgents(processingAgentIds: string[]) {
    this.processingAgents = {};

    processingAgentIds.forEach(id => {
      this.processingAgents[id] = true;
    });

    this.cdr.detectChanges();
  }

  onSelect(agent: AiAgentModel) {
    if (!this.processingAgents[agent.id]) {
      this.onAgentSelected.emit(agent);
    }
  }

  onSelectRuleBased() {
    if (!this.processingAgents['triggerRule']) {
      this.onTriggerRule.emit();
    }
  }
}
